import { Dropdown, DropdownProps } from 'primereact/dropdown';
import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useSearchParams } from 'react-router-dom';
import { GlobalContext } from '../../App';
import logo from '../../assets/images/trelleborg-logo.svg';
import { supportedLanguage } from '../../i18n/config';
import { getOutsideUrl } from '../../utils/getOutsideUrl';
import './Header.css';

interface Props {
  setLang: React.Dispatch<React.SetStateAction<string>>;
  lang: string;
}

const selectedItemTemplate = (option: any, prop: DropdownProps) => {
  return option.label.split(' ')[0];
};

const itemTemplate = (option: any, prop: DropdownProps) => {
  const splitLabel = option.label.split('|');
  return (
    <>
      <span className="item--label font-bold">{splitLabel[0]}</span>
      {splitLabel[1] ? <span className="pl-2">|</span> : ''}
      <span className="item--native pl-2">{splitLabel[1]}</span>
    </>
  );
};

const getLanguage = (lang: string) => {
  switch (lang) {
    case 'en':
      return 'EN';
    case 'de':
      return 'DE';
    case 'zh':
      return 'ZH';
    default:
      return 'EN';
  }
};

const escapeHTML = (str: string) => {
  return str.replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

const Header: React.FC<Props> = ({ lang, setLang }) => {
  let activeClassName = 'nav-active';
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const ctx = useContext(GlobalContext);
  useEffect(() => {
    let script = null;
    const cookie = document.getElementById('CookieConsent');
    if (cookie) {
      cookie.setAttribute('data-culture', getLanguage(lang));
      (window as any).CookieInformation.loadConsent();
    } else {
      script = document.createElement('script');
      script.src = 'https://policy.app.cookieinformation.com/uc.js';
      script.type = 'text/javascript';
      script.id = 'CookieConsent';
      script.dataset.culture = getLanguage(lang);
      document.body.appendChild(script);
      script.onload = () => {
        import('./cookie.js').then((src) => src.default());
      };
    }
  }, [lang]);

  useEffect(() => {
    const lang = searchParams.get('lang');
    if (lang && supportedLanguage.includes(lang)) setLang(lang);
    const failSafe = searchParams.get('failSafe');
    failSafe &&
      ctx.updateGlobalCtx({
        ...ctx,
        failSafe: failSafe === 'true' ? true : false,
      });
  }, [searchParams, setLang]);
  const updatorFunction = () => {
    ctx.updateGlobalCtx({
      ...ctx,
      currentView: 'GRID',
      currentCategory: '',
      failSafe: false,
      kg: '',
      rpm: '',
      noOfMount: '',
      results: [],
      multiSortMeta: { sortField: '', sortOrder: 0 },
    });
  };
  return (
    <header>
      <div className="tb-navbar tb-header flex justify-content-between align-items-center px-3 py-3  md:px-4 md:py-3 lg:px-5 lg:py-3 pb-0 md:pb-0 ">
        <div className="flex align-items-end">
          <a href={getOutsideUrl('')} className="pr-3 cursor-pointer">
            <img
              src={logo}
              width={'106px'}
              height={'45px'}
              alt="trelleborg-logo"
            />
          </a>
          <h1 className="app-title">ANTIVIBRATION SOLUTIONS</h1>
        </div>
        <div className="tb-header__right flex align-items-center">
          <div>
            <Dropdown
              panelClassName="tb-header__right__panel"
              value={lang}
              options={[
                { label: t('ENGLISH'), value: 'en' },
                { label: t('GERMAN'), value: 'de' },
                { label: t('CHINESE'), value: 'zh' },
              ]}
              valueTemplate={selectedItemTemplate}
              itemTemplate={itemTemplate}
              onChange={(e) => {
                setLang(e.value);
                const regex = new RegExp(/lang=(en|de|zh)/);
                // window.location.hash = window.location.hash.replace(regex, '');
                // window.location.reload();
                var sanitizedHash = escapeHTML(window.location.hash);
                window.location.hash = sanitizedHash.replace(regex, '');
              }}
            ></Dropdown>
          </div>
        </div>
      </div>
      <nav className="navbar flex justify-content-center">
        <section className="flex">
          <NavLink
            className={({ isActive }) => (isActive ? activeClassName : '')}
            to={'/'}
            onClick={updatorFunction}
          >
            {t('FIND_AVS_MOUNT')}
          </NavLink>
          <NavLink
            className={({ isActive }) => (isActive ? activeClassName : '')}
            to={'/catalogue'}
            onClick={updatorFunction}
          >
            {t('VIEW_CATALOGUE')}{' '}
          </NavLink>
        </section>
      </nav>
    </header>
  );
};

export default Header;
